var map = {
	"./map_1864.png": 48,
	"./map_1865.png": 49,
	"./map_1866.png": 50,
	"./map_1867.png": 51,
	"./map_1868.png": 52,
	"./map_1869.png": 53,
	"./map_1870.png": 54,
	"./map_1871.png": 55,
	"./map_1872.png": 56,
	"./map_1873.png": 57,
	"./map_1874.png": 58,
	"./map_1875.png": 59,
	"./map_1876.png": 60,
	"./map_1877.png": 61,
	"./map_1878.png": 62,
	"./map_1879.png": 63,
	"./map_1880.png": 64,
	"./map_1881.png": 65,
	"./map_1882.png": 66,
	"./map_1883.png": 67,
	"./map_1884.png": 68,
	"./map_1885.png": 69,
	"./map_1886.png": 70,
	"./map_1887.png": 71,
	"./map_1888.png": 72,
	"./map_1889.png": 73,
	"./map_1890.png": 74,
	"./map_1891.png": 75,
	"./map_1892.png": 76,
	"./map_1893.png": 77,
	"./map_1894.png": 78,
	"./map_1895.png": 79,
	"./map_1896.png": 80,
	"./map_1897.png": 81,
	"./map_1898.png": 82,
	"./map_1899.png": 83,
	"./map_1900.png": 84,
	"./map_1901.png": 85,
	"./map_1902.png": 86,
	"./map_1903.png": 87,
	"./map_1904.png": 88,
	"./map_1905.png": 89,
	"./map_1906.png": 90,
	"./map_1907.png": 91,
	"./map_1908.png": 92,
	"./map_1909.png": 93,
	"./map_1910.png": 94,
	"./map_1911.png": 95,
	"./map_1912.png": 96,
	"./map_1913.png": 97,
	"./map_1914.png": 98,
	"./map_1915.png": 99,
	"./map_1916.png": 100,
	"./map_1917.png": 101,
	"./map_1918.png": 102,
	"./map_1919.png": 103,
	"./map_1920.png": 104,
	"./map_1921.png": 105,
	"./map_1922.png": 106,
	"./map_1923.png": 107,
	"./map_1924.png": 108,
	"./map_1925.png": 109,
	"./map_1926.png": 110,
	"./map_1927.png": 111,
	"./map_1928.png": 112,
	"./map_1929.png": 113,
	"./map_1930.png": 114,
	"./map_1931.png": 115,
	"./map_1932.png": 116,
	"./map_1933.png": 117,
	"./map_1934.png": 118,
	"./map_1935.png": 119,
	"./map_1936.png": 120,
	"./map_1937.png": 121,
	"./map_1938.png": 122,
	"./map_1939.png": 123,
	"./map_1940.png": 124,
	"./map_1941.png": 125,
	"./map_1942.png": 126,
	"./map_1943.png": 127,
	"./map_1944.png": 128,
	"./map_1945.png": 129,
	"./map_1946.png": 130,
	"./map_1947.png": 131,
	"./map_1948.png": 132,
	"./map_1949.png": 133,
	"./map_1950.png": 134,
	"./map_1951.png": 135,
	"./map_1952.png": 136,
	"./map_1953.png": 137,
	"./map_1954.png": 138,
	"./map_1955.png": 139,
	"./map_1956.png": 140,
	"./map_1957.png": 141,
	"./map_1958.png": 142,
	"./map_1959.png": 143,
	"./map_1960.png": 144,
	"./map_1961.png": 145,
	"./map_1962.png": 146,
	"./map_1963.png": 147,
	"./map_1964.png": 148,
	"./map_1965.png": 149,
	"./map_1966.png": 150,
	"./map_1967.png": 151,
	"./map_1968.png": 152,
	"./map_1969.png": 153,
	"./map_1970.png": 154,
	"./map_1971.png": 155,
	"./map_1972.png": 156,
	"./map_1973.png": 157,
	"./map_1974.png": 158,
	"./map_1975.png": 159,
	"./map_1976.png": 160,
	"./map_1977.png": 161,
	"./map_1978.png": 162,
	"./map_1979.png": 163,
	"./map_1980.png": 164,
	"./map_1981.png": 165,
	"./map_1982.png": 166,
	"./map_1983.png": 167,
	"./map_1984.png": 168,
	"./map_1985.png": 169,
	"./map_1986.png": 170,
	"./map_1987.png": 171,
	"./map_1988.png": 172,
	"./map_1989.png": 173,
	"./map_1990.png": 174,
	"./map_1991.png": 175,
	"./map_1992.png": 176,
	"./map_1993.png": 177,
	"./map_1994.png": 178,
	"./map_1995.png": 179,
	"./map_1996.png": 180,
	"./map_1997.png": 181,
	"./map_1998.png": 182,
	"./map_1999.png": 183,
	"./map_2000.png": 184,
	"./map_2001.png": 185,
	"./map_2002.png": 186,
	"./map_2003.png": 187,
	"./map_2004.png": 188,
	"./map_2005.png": 189,
	"./map_2006.png": 190,
	"./map_2007.png": 191,
	"./map_2008.png": 192,
	"./map_2009.png": 193,
	"./map_2010.png": 194,
	"./map_2011.png": 195,
	"./map_2012.png": 196,
	"./map_2013.png": 197,
	"./map_2014.png": 198,
	"./map_2015.png": 199,
	"./map_2016.png": 200,
	"./map_2017.png": 201,
	"./map_2018.png": 202,
	"./map_2019.png": 203
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47;